import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { CivicFacilitiesModel } from 'types/api'
import { BaseParams } from 'types/utils'
import { civicFacilitiesQueryKey } from './useCivicFacilities'

export function useCreateCivicFacilities() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function createCivicFacility({
    body
  }: BaseParams<CivicFacilitiesModel, 'POST'>) {
    const response = await apiClient.post<CivicFacilitiesModel>(
      SNA_PREFIX + 'civic-facilities/',
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: createCivicFacility,
    onSuccess: () => {
      toast.success({ message: t('civicFacilityCreated') })
      queryClient.invalidateQueries({ queryKey: [...civicFacilitiesQueryKey] })
    },
    onError: () => {
      toast.error({ message: t('civicFacilityCreateError') })
    }
  })
}
